import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocument = createSelector(
  [(store: RootState) => store.documentSupervisorShow.document],
  (data) => data
);
